
import "../Navbar/Navbar.css";
const Navbar = () => {
  return (
    <div className='mainContainer'>
        <div className='UpperleftSide_logo'><img src="logo/logo.png" alt="logoImg" className="logoNavbar" /></div>
        <div className='UpperRightSide_links'>
            <ul>
                <li>Home</li>
              
            </ul>
        </div>
        


    </div>
  )
}

export default Navbar